import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../auth';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Dropdown } from 'react-bootstrap';
import { BsGearFill } from 'react-icons/bs';
import { CiLogout } from 'react-icons/ci';
import mySound from '../../../assets/notificattion/notification.mp3'
import useSound from 'use-sound';
import { axiosAuth } from '../../../api';

function HeaderNotif() {

    const { setUserInfo, accessToken, setAccessToken } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [listPcpPenjualan, setListPcpPenjualan] = useState([]);
    const [listPcpSewa, setListPcpSewa] = useState([]);
    const [previousFilteredPcpPenjualan, setPreviousFilteredPcpPenjualan] = useState([]);
    const [previousFilteredPcpSewa, setPreviousFilteredPcpSewa] = useState([]);
    const [playSound] = useSound(mySound);

    const navigate = useNavigate();

    const retrievePcpPenjualan = () => {

        axiosAuth.get(`/api/pcp`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                const filterData = res.data.data.filter(item => item.status === "pending" && item.lead?.status != 0);

                setListPcpPenjualan(filterData);

            }).catch(err => {
                console.error(err);

            })
    };

    const retrievePcpSewa = () => {

        axiosAuth.get(`/api/pcp/sewa`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                const filterData = res.data.data.filter(item => item.status === "pending");

                setListPcpSewa(filterData);

            }).catch(err => {
                console.error(err);

            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrievePcpPenjualan(true);
        if (accessToken !== undefined) retrievePcpSewa(true);
    }, [accessToken]);

    const intervalMinutes = 1;

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (accessToken !== undefined) {
                retrievePcpPenjualan(false);
                retrievePcpSewa(false);
            }
        }, intervalMinutes * 60000);

        return () => clearInterval(intervalId);
    }, [accessToken]);


    useEffect(() => {

        if (JSON.stringify(listPcpPenjualan) !== JSON.stringify(previousFilteredPcpPenjualan)) {

            playSound();

            Swal.fire({
                icon: 'info',
                title: 'PCP Penjualan Baru!',
                showConfirmButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    setPreviousFilteredPcpPenjualan(listPcpPenjualan.slice());
                }
            });
        }
    }, [listPcpPenjualan, previousFilteredPcpPenjualan]);

    useEffect(() => {

        if (JSON.stringify(listPcpSewa) !== JSON.stringify(previousFilteredPcpSewa)) {

            playSound();

            Swal.fire({
                icon: 'info',
                title: 'PCP Sewa Baru!',
                showConfirmButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    setPreviousFilteredPcpSewa(listPcpSewa.slice());
                }
            });
        }
    }, [listPcpSewa, previousFilteredPcpSewa]);


    const handleSubmitLogout = async () => {
        const confirmDelete = await Swal.fire({
            title: 'Apakah anda yakin ingin keluar dari aplikasi?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Keluar',
            cancelButtonText: 'Batal',
        });

        if (!confirmDelete.isConfirmed) {

            return;
        }

        try {
            await axiosAuth.post(
                '/api/auth/logout',
                {},
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        withCredentials: true,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('accessToken');
            setUserInfo();
            setAccessToken();

            Swal.fire({
                icon: 'success',
                title: 'Proses keluar berhasil!',
                showConfirmButton: false,
                timer: 2000,
            });
            navigate('/');
        } catch (error) {
            console.error(error)
            Swal.fire({
                icon: 'error',
                title: 'Warning!',
                text: 'Proses keluar gagal!',
            });
        }
    };

    return (
        <div className="container-logout-web" style={{ fontFamily: 'Poppins-Regular' }}>
            <Dropdown style={{ marginLeft: '0px' }}>
                <Dropdown.Toggle variant="btn" data-bs-theme={theme === 'light' ? 'dark' : ''} style={{ borderRadius: '0px', border: 'none', boxShadow: 'none' }}>
                    <BsGearFill size={18} color={theme === 'light' ? '#FFFFFF' : '#222222'} />
                    {
                        (listPcpPenjualan?.length === 0 && listPcpSewa?.length === 0) ? (
                            <></>
                        ) : (
                            <>
                                <div
                                    id='customBadge'
                                    style={{
                                        fontFamily: 'Poppins-Regular',
                                        backgroundColor: theme === 'light' ? '#12B3ED' : '#2f4b7c',
                                        color: theme === 'light' ? '#121212' : '#FFFFFF',
                                    }}
                                >
                                    {(listPcpPenjualan?.length || 0) + (listPcpSewa?.length || 0)}
                                </div>
                            </>
                        )
                    }
                </Dropdown.Toggle>
                <Dropdown.Menu id={theme === 'light' ? 'dropdownMenuDark' : 'dropdownMenuLight'}>
                    <Dropdown.Item
                        id={theme === 'light' ? 'dropdownItem1Dark' : 'dropdownItem1Light'}
                        className="d-flex align-items-center justify-content-center my-3"
                        onClick={handleSubmitLogout}
                    >
                        <CiLogout size={25} className='me-2' color={theme === 'light' ? '#FFFFFF' : '#707070'} />
                        <span style={{ fontFamily: 'Poppins-Light', color: theme === 'light' ? '#FFFFFF' : '#707070' }}>Keluar</span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default HeaderNotif
